import script from "./TablaMovimientos.vue?vue&type=script&setup=true&lang=js"
export * from "./TablaMovimientos.vue?vue&type=script&setup=true&lang=js"

import "./TablaMovimientos.vue?vue&type=style&index=0&id=18b80a70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b80a70"]])

export default __exports__